module.exports = __webpack_public_path__ + "d682dd8e3f9e623f1988bac38bc8ef58.png";